{
  "auth": {
    "listItem1": "Para nosotros en Oldcastle Infrastructure, la seguridad es un valor fundamental. Nuestro objetivo es lograr CERO DAÑOS en nuestras instalaciones para garantizar que todas las personas regresen a casa en las mismas condiciones en que llegaron. Nos protegemos mutuamente, nos cuidamos unos a otros y, cuando vemos algo, nos detenemos y actuamos.",
    "listItem2": "Animamos encarecidamente a todos a que dediquen tiempo a incorporar la seguridad a su estilo de vida, independientemente del entorno.",
    "subtitle": "En Oldcastle, la seguridad es nuestra prioridad.",
    "title": "Orientación en línea para contratistas"
  },
  "contractor": {
    "dashboard": {
      "title": "Orientación en línea para contratistas {year}",
      "accessMessage": "Complete la Orientación en Línea para Contratistas {year} para obtener acceso a sus sitios en los Estados Unidos.",
      "bulletPoints": [
        "Al final del proceso, podrá elegir el sitio al que desea acceder.",
        "Después de completar la orientación, recibirá un certificado que podrá mostrar a un responsable del sitio para ingresar."
      ],
      "completedTitle": "¡Su Orientación en Línea para Contratistas ha sido completada para {year}!",
      "assignedSites": "Se le ha asignado al siguiente sitio{plural}.",
      "certificateSent": "¡El certificado ha sido enviado!",
      "certificateResend": "Reenviar certificado",
      "explore": "Explorar los productos y líneas de Oldcastle",
      "learn": "Conocer más sobre Oldcastle y sus valores",
      "addToSite": "Añádame a un sitio"
    },
    "label": "Contratista",
    "list": "Lista de contratistas",
    "search_placeholder": "Escriba el nombre de un contratista o empresa..."
  },
  "orientation": {
    "title": "Orientación en línea para contratistas",
    "preface": {
      "title": "Prefacio",
      "content": "<p>Tenga en cuenta que esta orientación será <b>calificada al final</b>. Debe leer la orientación cuidadosamente y entender su contenido.</p><p>Si no obtiene la calificación mínima aceptada por Oldcastle, se le pedirá que vuelva a hacer el test hasta que lo apruebe.</p>"
    },
    "testButton": "Pon a prueba tus conocimientos",
    "quiz": {
      "title": "Test de Comprensión Final",
      "gradingTitle": "Proceso de Calificación",
      "gradingContent": "<p class='mb-15'>Este test de comprensión es calificado. Si no obtiene una calificación final de <strong>al menos {passing} %</strong> o si no responde correctamente <strong>{goodAnswersRequired} preguntas de {totalQuestions}</strong>, deberá repetir el test.</p><p>Si aprueba, podrá seleccionar el sitio que desea vincular a tu certificado y, luego, podrá visitar este sitio OI específico.</p>",
      "start": "Realizar el test",
      "question": "Pregunta",
      "true": "Verdadero",
      "false": "Falso",
      "right": "¡Respuesta correcta!",
      "wrong": "¡Respuesta incorrecta!",
      "submit": "Enviar mi respuesta",
      "next": "Siguiente pregunta",
      "finish": "Enviar el test",
      "grade": "Calificación : {grade} %",
      "failed": "<p class=\"quiz-fail__text mb-15\">Desafortunadamente, no aprobó el test. Le faltaron <strong>{missed} preguntas</strong>. Para obtener su certificado, debe tener una calificación de al menos {passing}%. Por favor, repita el test.</p><p class=\"quiz-fail__text\">Además, no haga clic en \"Cancelar\" antes de aprobar el test y confirmar su sitio vinculado. Si lo hace, perderá todo su progreso.</p>",
      "retake": "Reiniciar la orientación"
    },
    "passed": {
      "congrats": "¡Felicidades! Ha completado con éxito la orientación en línea para contratistas.",
      "email": "Su certificado ha sido enviado por correo electrónico. Por favor, preséntalo a su contacto tan pronto como llegues al sitio.",
      "chooseSite": "El último paso es elegir el sitio al que desea acceder. Podrá modificarlo hasta que complete la inducción en el sitio.",
      "successSite": "Ha seleccionado con éxito el siguiente sitio.",
      "editSite": "Podrá modificarlo hasta que complete la inducción en el sitio.",
      "chooseSiteBtn": "Eligir este sitio",
      "backHome": "Regresar a inicio"
    }
  },
  "reports": {
    "allCompaniesByYear": {
      "subtitle": "que tienen contratistas",
      "title": "Todas las empresas"
    },
    "allContractorsBySite": {
      "subtitle": "para todos los sitios o por sitio específico",
      "title": "Todos los contratistas"
    },
    "allContractorsInfo": {
      "subtitle": "con información",
      "title": "Todos los contratistas"
    },
    "allSites": {
      "subtitle": "con administradores de sitio",
      "title": "Todos los sitios"
    }
  },
  "quick_actions": {
    "company:add": {
      "text": "Añade una empresa para que los contratistas puedan identificarse al registrarse.",
      "title": "Añadir una empresa"
    },
    "site:add": {
      "text": "Añade un sitio para iniciar tu negocio allí.",
      "title": "Añadir un sitio"
    },
    "site-manager:add": {
      "text": "Añade un administrador a un sitio vacío, reemplaza un administrador existente o crea uno nuevo.",
      "title": "Añadir un administrador de sitio"
    },
    "title": "Acciones rápidas"
  },
  "address": "DIRECCIÓN",
  "add_company_info": "Agregar información de la empresa",
  "add_contractor": "Agregar contratista",
  "add_cover_image": "Añadir imagen de portada",
  "add_existing_manager": "Agregar administrador existente",
  "add_manager": "Agregar administrador",
  "add_new_manager": "Agregar nuevo administrador",
  "add_site_info": "Agregar información del sitio",
  "add_site_manager": "Agregar un administrador del sitio",
  "all_contractors_with_info_linked_to_selected_site": "Todos los contratistas con información vinculada al sitio seleccionado",
  "all_sites": "Todos los sitios",
  "back_to_dashboard": "Volver al panel de control",
  "cancel": "Cancelar",
  "choose_existing_manager": "Elegir un administrador existente",
  "choose_site_to_link": "Elige un sitio para enlazar",
  "close_window": "Cerrar ventana",
  "companies": "Empresas",
  "companies_profile": "Perfil de la empresa",
  "company": "Compañía",
  "company_been_added": "Esta empresa ha sido añadida. La información sobre ella se puede editar en el perfil de la empresa.",
  "company_name": "Nombre de empresa",
  "complete": "Completar",
  "confirm": "Confirmar",
  "confirmation_email_sent": "Se ha enviado un correo electrónico de confirmación al usuario. Será posible ver su perfil una vez que se verifique el correo electrónico y el usuario haya creado su cuenta.",
  "contractor_name": "Nombre del contratista",
  "contractor_has_no_site": "Este contratista aún no tiene un sitio asignado.",
  "contractor_has_not_completed_inductions_that_year": "Este contratista no ha completado ninguna inducción ese año.",
  "contractor_has_not_completed_inductions_this_year": "Este contratista no ha completado ninguna inducción este año.",
  "contractor_has_not_done_inductions_yet": "Este contratista aún no ha realizado ninguna inducción.",
  "contractors": "Contratistas",
  "contractors_profile": "Perfil del contratista",
  "create_a_report": "Crear un informe",
  "create_new_manager": "Crear nuevo gerente",
  "create_new_section": "Crear nueva sección",
  "current_status": "Estado actual",
  "date_of_birth": "Fecha de nacimiento",
  "display_info_from_site": "Muestra información de un sitio específico",
  "done": "Hecho",
  "edit_cover_image": "Editar imagen de portada",
  "edit_the_orientation": "Editar la orientación",
  "email": "Correo electrónico",
  "errors": {
    "media_upload": "Error al cargar el archivo multimedia."
  },
  "date_of_completion_online_orientation": "Fecha de finalización - Orientación en línea",
  "final_comprehension_test": "Prueba de comprensión final",
  "first_name": "Nombre",
  "forgot_password": "¿Olvidaste tu contraseña?",
  "incomplete": "Incompleto",
  "induction_complete_confirmation": "¿Está seguro de que desea realizar la siguiente inducción en el sitio?",
  "induction_completed_on": "Inducción completada en",
  "last_name": "Apellido",
  "loading": "Cargando...",
  "logout_success": "Desconectado exitosamente",
  "manager": "Gerente",
  "manager_detach_confirmation": "¿Está seguro de que desea eliminar a este administrador de este sitio? Esta acción no eliminará su perfil.",
  "name": "Nombre",
  "new_password": "Nueva contraseña",
  "next": "Proximo",
  "next_question": "Siguiente pregunta",
  "orientation_published_successfully": "Orientación publicada con éxito.",
  "no_manager_history_for_year": "Este sitio no tiene historial de gerentes para este año.",
  "no_notifications": "No tienes notificaciones",
  "notifications": "Notificaciones",
  "now_manager_of": "ahora es gerente de",
  "on-site_training": "Formación en el sitio",
  "on-site_training_status": "Estado de la formación en el sitio",
  "password": "Contraseña",
  "password_changed": "La contraseña se cambió correctamente.",
  "previous": "Previo",
  "previous_question": "Pregunta anterior",
  "profile": "Perfil",
  "publish_orientation": "Publicar la orientación",
  "remember_me": "Recuérdame",
  "resend": "Reenviar",
  "reset": "Restablecer",
  "reset_password": "Restablecer contraseña",
  "reset_password_email_sent": "Se envió correctamente un correo electrónico a <strong>{email}</strong> para restablecer la contraseña.",
  "results_in": "Resultados en",
  "review_choice": "Revisa la opción",
  "review_company_info": "Revisar información de la empresa",
  "review_site_info": "Revisar la información del sitio",
  "save": "Salvar",
  "save_changes": "Guardar cambios",
  "saving": "Guardando...",
  "search": "Buscar",
  "search_something": "Buscar algo...",
  "section": "seccion",
  "see_company_profile": "Ver perfil de empresa",
  "see_manager_profile": "Ver perfil del gerente",
  "see_more": "Voir plus",
  "see_previous_notifications": "Ver notificaciones anteriores",
  "see_site_profile": "Ver perfil del sitio",
  "send": "Enviar",
  "session_expired": "Tu sesión ha caducado.",
  "sign_in": "Iniciar sesión",
  "sign_in_success": "Inicio de sesión exitoso.",
  "sign_up": "Registrarse",
  "sign_up_email_sent": "Se ha enviado un correo electrónico de validación a tu bandeja de entrada. Haz clic en el enlace del correo electrónico para confirmar.",
  "sign_up_success": "¡Te has registrado correctamente!",
  "site": "Sitio",
  "sites": "Sitios",
  "sites_profile": "Perfil del sitio",
  "site_been_added": "Se ha añadido como sitio web. Eventualmente, deberá vincularse un administrador de sitio.",
  "site_doesnt_have_managers": "Este sitio aún no tiene un administrador.",
  "site_has_managers": "Este sitio ya tiene uno o varios administradores. Puedes gestionar su rol más abajo o en el perfil del sitio.",
  "site_history": "Historial de sitios",
  "site_manager_history": "Historial del administrador del sitio",
  "site_manager_name": "Nombre del administrador del sitio",
  "site-managers": "Administradores del sitio",
  "site-managers_profile": "Perfil del administrador del sitio",
  "site_name": "Nombre del sitio",
  "site_names": "Nombre del sitio",
  "site_status_history": "Historial de estado del sitio",
  "switch_current_site": "Cambiar sitio actual",
  "start": "Iniciar",
  "to_do": "A hacer",
  "to_selected_site": "A el sitio",
  "year": "Año"
}
